<template>
    <div>
        <ion-card
            button
            class="c-coach-card"
            @click="goToCoach()"
            v-if="contractId && Object.keys(coach).length > 0"
        >
            <ion-grid>
                <ion-row>
                    <ion-col class="c-coach-card__text" size="7" size-md="9">
                        <div v-if="showGender">{{ genderText }}</div>
                        <div v-else class="u-m-bottom-small">
                            {{ vertragDescription }}
                        </div>
                        <div>
                            <h6 class="u-m-top-small">
                                <b>{{ coach.name }}</b>
                            </h6>
                        </div>
                        <div class="c-coach-card__contact">
                            <span class="icon-navi_nachrichten"></span
                            >&nbsp;&nbsp;kontaktieren
                        </div>
                    </ion-col>
                    <ion-col
                        class="c-coach-card__image"
                        size="5"
                        size-md="3"
                        :style="
                            'background-image: url(' +
                            baseurl +
                            api_static +
                            '?Mode=General&Function=BeraterImage&size=250&agentId=' +
                            coach.agentId +
                            ')'
                        "
                    >
                        <!-- <img :src="baseurl + api_static + '?Mode=General&Function=BeraterImage&agentId=' + coach.agentId"> -->
                    </ion-col>
                </ion-row>
            </ion-grid>
        </ion-card>
        <ion-card class="c-coach-card" v-else>
            <ion-grid>
                <ion-row>
                    <ion-col class="c-coach-card__text" size="7" size-md="9">
                        <div class="u-m-bottom-small">
                            <ion-skeleton-text
                                animated
                                style="width: 70%;"
                            ></ion-skeleton-text>
                        </div>
                        <div>
                            <h4>
                                <ion-skeleton-text
                                    animated
                                    style="width: 80%;"
                                ></ion-skeleton-text>
                                <ion-skeleton-text
                                    animated
                                    style="width: 80%;"
                                ></ion-skeleton-text>
                            </h4>
                        </div>
                        <div class="c-coach-card__contact">
                            <ion-skeleton-text
                                animated
                                style="width: 50%;"
                            ></ion-skeleton-text>
                        </div>
                    </ion-col>
                    <ion-col class="c-coach-card__image" size="5" size-md="3">
                        <ion-skeleton-text class="fill"></ion-skeleton-text>
                    </ion-col>
                </ion-row>
            </ion-grid>
        </ion-card>
    </div>
</template>

<script>
import { BASEURL } from "@/utils/globals";

export default {
    props: {
        contractId: {},
        motive: {},
        directContact: {},
        showGender: {
            required: false,
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            baseurl: BASEURL,
            api_static: process.env.VUE_APP_API_STATIC,
        };
    },
    mounted() {
        if (
            this.contractId &&
            this.contractId in this.$store.state.coaches.all === false
        ) {
            this.$store.cache.dispatch("coaches/getCoach", this.contractId);
        }
    },
    computed: {
        genderText() {
            let result = "Dein Berater";
            if (this.coach.gender && this.coach.gender === "W") {
                result = "Deine Beraterin";
            }
            return result;
        },
        coach() {
            let result = {};
            if (
                this.contractId &&
                this.contractId in this.$store.state.coaches.all
            ) {
                result = this.$store.state.coaches.all[this.contractId];
            }
            return result;
        },

        vertragDescription() {
            let result = "";
            if (
                this.contractId &&
                this.contractId in this.$store.state.contracts
            ) {
                result = this.$store.state.contracts[this.contractId]
                    .Description;
            }
            return result;
        },
    },
    methods: {
        goToCoach() {
            if (this.motive !== undefined) {
                this.$router.push({
                    name: "motive-beraterdetails",
                    params: {
                        motive: this.motive,
                        contractId: this.contractId,
                        directContact: this.directContact,
                    },
                });
            } else {
                this.$router.push({
                    name: "beraterdetails",
                    params: {
                        contractId: this.contractId,
                        directContact: this.directContact,
                    },
                });
            }
        },
    },
};
</script>

<style lang="scss" scoped>
.c-coach-card {
    border: solid 1px var(--ion-color-medium);
    padding: 0;
    &__contact {
        position: absolute;
        bottom: var(--gangl-padding-medium);
        width: 100%;
    }
    &__text {
        padding: var(--gangl-padding-medium);
        padding-bottom: var(--gangl-padding-xxlarge);
    }
    &__image {
        // padding: 0;
        background-size: cover;
        background-position: center;

        &:after {
            content: "";
            display: block;
            padding-bottom: 99%;
        }
    }
}
</style>
